<template>
  <v-container class="pt-6">
    <v-row>
      <v-col cols="12" v-if="gruposValidos.length">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text>
            <div class="mb-0 font-weight-bold text-h5 textPrimary--text text-center">
              Mis grupos
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Alerta de que no tienes grupos asignados -->
      <!-- Avisos -->
      <SinGrupos   v-if="!gruposValidos.length" />

      <!-- Grupos asignados -->
      <GruoisListAlumnos v-else/>

      <v-col cols="12">
        <!-- Avisos -->
        <v-row>

          <!-- CURSO DE INDUCCIÓN -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="verCursoInduccion">
            <v-card class="shadowCard" :to="{name: 'CursoInduccion'}">
              <v-img v-if="tipoCurso == 1" src="@/assets/backgrounds/induccion_adultos_fast.png"/></v-img>
              <v-img v-if="tipoCurso == 2" src="@/assets/backgrounds/induccion_adultos_inbi.png"/></v-img>
              <v-img v-if="tipoCurso == 3" src="@/assets/backgrounds/induccion_teens.png"/></v-img>
            </v-card>
          </v-col> -->

          <!-- VIDEOS DE YOUTUBE -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4">
            <v-card class="shadowCard" :to="{name: 'VideosYt'}">
              <v-img v-if="tipoCurso == 1" src="@/assets/backgrounds/learn.png"/></v-img>
              <v-img v-if="tipoCurso == 2" src="@/assets/backgrounds/learn.png"/></v-img>
              <v-img v-if="tipoCurso == 3" src="@/assets/backgrounds/learn.png"/></v-img>
            </v-card>
          </v-col> -->

          <!-- Curso de descuento -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="avisoDescuento.visible">
            <AvisoPago v-if="avisoDescuento.visible" :avisoDescuento="avisoDescuento" />
          </v-col> -->

          <!-- Calificar clase -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="encuesta.visible">
            <Encuesta v-if="encuesta.visible" :encuesta="encuesta"/>
          </v-col> -->

          <!-- Encuesta de satisfacción -->
          <v-col cols="12" sm="6" md="6" lg="4" v-if="encuestaSatis.visible">
            <EncuestaSatisfaccion v-if="encuestaSatis.visible" :encuestaSatis="encuestaSatis"/>
          </v-col>

          <!-- Beca siguiente nivel -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="becaNivel.visible">
            <BecaNivel v-if="becaNivel.visible" :becaNivel="becaNivel"/>
          </v-col> -->

          <!-- Calificar clase -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="encuestaPresencial.visible">
            <EncuestaPresencial v-if="encuestaPresencial.visible" :encuestaPresencial="encuestaPresencial"/>
          </v-col> -->

          <!-- Subir Video de 14vo nivel -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="subirVideo.visible">
            <CargarVideo v-if="subirVideo.visible" :subirVideo="subirVideo"/>
          </v-col> -->

          <!-- Curso del exciiiii -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4" v-if="accesoExci">
            <v-card class="shadowCard" :to="{name: 'MaterialExci'}">
              <v-img src="https://inbi.mx/public/images/infoexci.jpg"/></v-img>
            </v-card>
          </v-col> -->

          <!-- Aviso de comparte y gana -->
          <!-- <v-col cols="12" sm="6" md="6" lg="4">
            <ComparteGana/>
          </v-col> -->

        </v-row>
      </v-col>
    </v-row>

    <v-speed-dial
      right
      fixed
      style="bottom: 15%;"
    >
      <template v-slot:activator >
        <v-btn
          color="blue darken-2"
          dark
          fab
          @click="actualizarGrupos()"
        >
          <!-- @click="actualizarGrupos(), getCursoExci(), getEncuesta(), getEncuestaPresencial()" -->
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <!-- Alertas -->
    <Alerta         v-if="respuestaAlerta"         :parametros="parametros"/>
    <Loader         v-if="cargar"                  :loader="loader"/>
    <SinAcceso      v-if="alertaAcceso.estatus"    :alertaAcceso="alertaAcceso" @click="salirLogin()"/>

  </v-container>
</template>
<script>
  // Importar lebrerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');
  import { Clipboard } from '@capacitor/clipboard';

  /** Misma lista que `IDS_ENCUESTA_SATIS_SIEMPRE` en api-movil (encuestas.controllers.js) */
  const IDS_ENCUESTA_SATIS_SIEMPRE = [30025069, 14976, 8206]
  function encuestaSatisSiemprePorIdUsuarioLms (idUsuarioLms) {
    if (idUsuarioLms == null || idUsuarioLms === '') return false
    const n = Number(String(idUsuarioLms).trim())
    if (Number.isNaN(n)) return false
    return IDS_ENCUESTA_SATIS_SIEMPRE.includes(n)
  }

  // Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'
  import SinAcceso     from '@/components/alertas/SinAcceso.vue'

  import SinGrupos           from '@/components/grupos/SinGrupos.vue'
  import Encuesta            from '@/components/grupos/Encuesta.vue'
  import GruoisListAlumnos   from '@/components/grupos/GruoisListAlumnos.vue'

  // Avisos
  import AvisoPago           from '@/components/avisos/AvisoPago.vue'
  import ComparteGana        from '@/components/avisos/ComparteGana.vue'
  import EncuestaPresencial  from '@/components/avisos/EncuestaPresencial.vue'
  import BecaNivel           from '@/components/avisos/BecaNivel.vue'
  import CargarVideo         from '@/components/avisos/CargarVideo.vue'
  import EncuestaSatisfaccion from '@/components/avisos/EncuestaSatisfaccion.vue'

  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
    components:{
      Alerta,
      Loader,
      SinGrupos,
      Encuesta,
      SinAcceso,
      GruoisListAlumnos,
      AvisoPago,
      ComparteGana,
      EncuestaPresencial,
      BecaNivel,
      CargarVideo,
      EncuestaSatisfaccion
    },

    mixins:[validarErrores],

    data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

        alertaAcceso:{
          estatus: false,
        },

        encuesta:{
          visible: false
        },

        dialogComparteGana: false,

        respuestaAlerta:false,
        loader: true,
        cargar: false,

        avisoDescuento:{
          visible: false,
        },

        encuestaPresencial:{
          visible: false,
        },

        encuestaSatis:{
          visible: false,
          sinGrupo: false
        },

        becaNivel:{
          visible: false,
        },

        subirVideo:{
          visible: false,
          id_grupo: 0,
        },

        visibleEncuesta: false,
        accesoExci:false,
        verCursoInduccion: false,
        tipoCurso: 0
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
      
      gruposValidos() {
        return Array.isArray(this.getGrupos) ? this.getGrupos : []
      }
    },

    async created ( ){
      await this.actualizarGrupos()
      // await this.getAcceso( )
      // await this.getCursoExci( )
      // await this.getSubirVideo()
      // await this.getAnuncioDescuento()
      // await this.getEncuesta()
      // await this.getEncuestaPresencial()
      // await this.getBecaNivel() No se ocupa para inbi
      await this.getEncuestaSatisfaccion()
    },

    methods:{
      ...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

      getAcceso ( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('usuario.acceso/' + id_usuario).then( response => {
          // Guardamos los grupos
        }).catch( error =>{
          this.alertaAcceso.estatus = true
        }).finally(()=>{ this.cargar = false })
      },

      getSubirVideo( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('grabar.video/' + id_usuario).then( response => {
          this.subirVideo.visible = true
          this.subirVideo.id_grupo = response.body.id_grupo
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getCursoExci( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )
        // Hacemos la petición
        this.$http.get('exci.activar.usuario/' + id_usuario).then( response => {
          this.accesoExci = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuestaPresencial( ){
        const id_usuario_erp = base64.encode( this.getUsuarioLMS.iderp )
        const id_usuario     = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('encuestas.presencial/' + id_usuario).then( response => {
          this.encuestaPresencial.visible = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getBecaNivel( ){
        const id_usuario_erp = base64.encode( this.getUsuarioLMS.iderp )
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('encuestas.becanivel/' + id_usuario + '/' + id_usuario_erp).then( response => {
          this.becaNivel.visible = true
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuesta ( ) {
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('aviso.evaluacion/' + id_usuario).then( response => {
          this.encuesta.visible = true
          // Guardamos los grupos
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      getEncuestaSatisfaccion ( ) {
        // id LMS + iderp; el backend valida ventana (última semana del ciclo), encuesta previa y grupo alineado a la lista
        this.$http.post('encuestas.satisfaccion.habil', {
          id: this.getUsuarioLMS.id,
          iderp: this.getUsuarioLMS.iderp
        }).then( response => {
          const b = response.body || {}
          this.encuestaSatis = {
            visible: true,
            sinGrupo: !!b.sinGrupo,
            cicloNombre: b.cicloNombre,
            fechaInicioCiclo: b.fechaInicioCiclo,
            fechaFinCiclo: b.fechaFinCiclo,
            encuestaLunes: b.encuestaLunes,
            encuestaDomingo: b.encuestaDomingo
          }
        }).catch( error =>{
          const msg = (error.body && error.body.message) || (error.data && error.data.message) || ''
          /*if (encuestaSatisSiemprePorIdUsuarioLms(this.getUsuarioLMS.id) && /encuesta ya realizada/i.test(String(msg))) {*/
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      esGrupoTeens (grupo) {
        const curso = String(grupo.curso || '').toLowerCase()
        const nombre = String(grupo.grupo || grupo.nombre || '').toUpperCase()
        return curso.includes('teen') || nombre.includes('TEENS')
      },

      calificacionAprobada (calificacion) {
        const n = Number(calificacion)
        return !Number.isNaN(n) && n >= 70
      },

      aplicarAlertasCalificacion (grupo) {
        const { calificacion_final_primera_oportunidad, calificacion_final_segunda_oportunidad } = grupo

        grupo.reprobado = false
        grupo.extraordinario = false

        if (calificacion_final_primera_oportunidad != 'SIN CALIFICACION') {
          if (parseFloat(calificacion_final_primera_oportunidad) >= 70 && parseFloat(calificacion_final_segunda_oportunidad) < 70) {
            grupo.reprobado = true
          }

          if (parseFloat(calificacion_final_primera_oportunidad) < 70 && parseFloat(calificacion_final_segunda_oportunidad) < 70) {
            grupo.reprobado = true
          }
        }
      },

      aplicarAccesoPorPrograma (grupos) {
        if (!grupos.length) return

        const grupoReprobado = grupos.find((el) => el.primera == 1 && el.segunda == 1)

        if (grupoReprobado) {
          for (const i in grupos) {
            const { calificacion_final_primera_oportunidad, calificacion_final_segunda_oportunidad } = grupos[i]

            if (grupos[i] == grupoReprobado) {
              if (calificacion_final_primera_oportunidad < 70 && calificacion_final_segunda_oportunidad == '') {
                grupos[i].reprobado = false
                grupos[i].extraordinario = true
              } else if (calificacion_final_segunda_oportunidad < 70) {
                grupos[i].reprobado = true
              } else {
                grupos[i].reprobado = false
              }

              grupos[i].habil = true
            } else {
              grupos[i].habil = false
            }
          }
          return
        }

        let nivelAnteriorAprobado = true
        for (const i in grupos) {
          const grupo = grupos[i]
          grupo.habil = parseInt(i) === 0 || nivelAnteriorAprobado
          this.aplicarAlertasCalificacion(grupo)
          nivelAnteriorAprobado = this.calificacionAprobada(grupo.calificacion_final_primera_oportunidad) ||
            this.calificacionAprobada(grupo.calificacion_final_segunda_oportunidad)
        }
      },

      procesarGruposAlumno (grupos) {
        const lista = Array.isArray(grupos) ? [...grupos] : []
        const ordenarPorNivel = (arr) => arr.sort((a, b) => a.id_nivel - b.id_nivel)
        const teens = ordenarPorNivel(lista.filter((grupo) => this.esGrupoTeens(grupo)))
        const adultos = ordenarPorNivel(lista.filter((grupo) => !this.esGrupoTeens(grupo)))

        this.aplicarAccesoPorPrograma(teens)
        this.aplicarAccesoPorPrograma(adultos)

        return [...teens, ...adultos]
      },

      actualizarGrupos ( ) {
        this.cargar = true
        this.grabarGruposUsuario( [] )
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('grupos.alumno/' + id_usuario).then( response => {
          const grupos = response.body || []
          // Validar que sea un array
          if (Array.isArray(grupos)) {
            this.grabarGruposUsuario( this.procesarGruposAlumno(grupos) )
          } else {
            this.validarErrorDirecto('Error: La respuesta del servidor no es válida')
          }
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      getAnuncioDescuento( ) {
        return this.$http.get('usuario.anuncio.descuento').then( response => {
          this.avisoDescuento['aviso'] = response.body
          this.avisoDescuento.visible = true
        }).catch( error =>{
          // this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

    }
  }
</script>

<style scoped>

  /* STYLE FOR AVISO PAGO  */
  .responsive-banner {
    min-width: 230px;
    position: relative;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    background-image: linear-gradient(to bottom right, #5BC2D4, #84D9E0);
    background-repeat: no-repeat;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .container-envelope {
    padding: 35px 15px;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .col-xs-12 {
    text-align: center;
  }

  img {
    width: 100%;
    position: relative;
  }

  span:after,
  span:before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    width: 50px;
    height: 50px;
  }

  .circle-a:before {
    width: 500px;
    height: 500px;
    top: -300px; left: 52%;
    -webkit-transform: translate(-50%,0);
    -ms-transform: translate(-50%,0);
    transform: translate(-50%,0);
  }

  .circle-a:after {
    top: 160px;
    right: 10%;
  }

  .circle-b:before {
    top: 60%;
    left: -25px;
  }

  .circle-b:after {
    width: 150px;
    height: 150px;
    bottom: -70px;
    right: -70px;
  }

  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }

  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }

</style>
